import React from "react";
import './tag.scss';

const Tag = props => {
    return(
        <div className="e-tag"># {props.text}</div>
    );
}

export default Tag;